import { render, staticRenderFns } from "./BlockDraftsProperties.vue?vue&type=template&id=9dd242dc&scoped=true&"
import script from "./BlockDraftsProperties.vue?vue&type=script&lang=js&"
export * from "./BlockDraftsProperties.vue?vue&type=script&lang=js&"
import style0 from "./BlockDraftsProperties.vue?vue&type=style&index=0&id=9dd242dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd242dc",
  null
  
)

export default component.exports